import TextCtaType from '~/constants/TextCtaType';
import { useConfiguration } from '~/context/common/StaticContext';
import useTextCtaButtonState from './useTextCtaButtonState';

export default function useTextCtaButtonCopy(): string | null {
  const { shouldUseTitleCasing } = useConfiguration();
  const { type } = useTextCtaButtonState();

  const textCtaTypes: Record<TextCtaType, string | null> = {
    [TextCtaType.CancelPreOrder]: shouldUseTitleCasing
      ? 'Cancel Pre-Order'
      : 'Cancel pre-order',
    [TextCtaType.Default]: null
  };

  return textCtaTypes[type];
}
